/**
 * Estado de la ordenación de expedientes por Nº documento (RN-001 a RN-006).
 * selectedCertificate/certificateTypeId condiciona sortDirection: sin certificado
 * seleccionado, la ordenación queda deshabilitada e ignorada.
 */
export interface IDocumentSortState {
    certificateTypeId?: number;
    direction?: string;
    contextKey?: string;
}

export const emptyDocumentSortState = (): IDocumentSortState => {
    return {};
};
